import classNames from 'classnames/bind';
import styles from './InvoiceOpen.module.scss';
import TableClassicReport from '../base/TableClassicReport';
import { useEffect, useState } from 'react';
import { IInvoiceOpenRecord, IInvoiceOpenSalesRepRecord, IPaginationReport } from '~/utils/interface/report';
import reportApi from '~/apis/report';
import { ColumnType } from '~/utils/types/common';
import dayjs from 'dayjs';

const cx = classNames.bind(styles);

const InvoiceOpen = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IInvoiceOpenRecord[]>([]);
  const [pagination, setPagination] = useState<IPaginationReport>({
    totalItems: 0,
    totalPage: 0,
    page: 1,
    limit: 10,
    skip: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await reportApi.getInvoiceOpen({ page: pagination.page });
        setData(response.data?.data?.responses ?? []);
        setPagination(response.data?.data?.pagination ?? {
          totalItems: 0,
          totalPage: 0,
          page: 1,
          limit: 10,
          skip: 0,
        });
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch invoice open sales rep', error);
        setLoading(false);
      }
    };
    fetchData();
  }, [pagination.page]);


  const columns: Array<ColumnType> = [
    {
      id: "relatedRecords",
      labelHeader: "Related Records",
      renderCell: (invoice: IInvoiceOpenRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{invoice.relatedContact.name ? `${invoice.relatedContact.name} (Contact)` : "-"}</p>
          <p className={cx("text-content")}>{invoice.uniqueCode ? `${invoice.uniqueCode} (Job)` : "-"}</p>
        </div>
      ),
    },
    {
      id: "status",
      labelHeader: "Status",
      renderCell: (invoice: IInvoiceOpenRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{invoice.status || "-"}</p>
        </div>
      ),
    },
    {
      id: "number",
      labelHeader: "Number",
      renderCell: (invoice: IInvoiceOpenRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{invoice.uniqueCode || "-"}</p>
        </div>
      ),
    },
    {
      id: "total",
      labelHeader: "Total",
      renderCell: (invoice: IInvoiceOpenRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{`$${invoice.total || "0"}`}</p>
        </div>
      ),
    },
    {
      id: "totalPaid",
      labelHeader: "Total Paid",
      renderCell: (invoice: IInvoiceOpenRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{`$${invoice.paid || "0"}`}</p>
        </div>
      ),
    },
    {
      id: "balance",
      labelHeader: "Balance",
      renderCell: (invoice: IInvoiceOpenRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{`$${Number(Number(invoice.total) - Number(invoice.paid) || 0)}`}</p>
        </div>
      ),
    },
    {
      id: "due",
      labelHeader: "Due",
      renderCell: (invoice: IInvoiceOpenRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{`$${Number(Number(invoice.total) - Number(invoice.paid) || 0)}`}</p>
        </div>
      ),
    },
    {
      id: "createdBy",
      labelHeader: "Created By",
      renderCell: (invoice: IInvoiceOpenRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{invoice.createdByAccount.name || "-"}</p>
        </div>
      ),
    },
    {
      id: "dateCreated",
      labelHeader: "Date Created",
      renderCell: (invoice: IInvoiceOpenRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{dayjs(invoice.createdAt).format("MM/DD/YYYY") || "-"}</p>
        </div>
      ),
    },
    {
      id: "dateInvoice",
      labelHeader: "Date Invoice",
      renderCell: (invoice: IInvoiceOpenRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{dayjs(invoice.dateInvoiced).format("MM/DD/YYYY") || "-"}</p>
        </div>
      ),
    },
    {
      id: "dateUpdated",
      labelHeader: "Date Updated",
      renderCell: (invoice: IInvoiceOpenRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{dayjs(invoice.updatedAt).format("MM/DD/YYYY") || "-"}</p>
        </div>
      ),
    },
  ];

  return (
    <TableClassicReport
      title="Invoice Open"
      columns={columns}
      data={data}
      page={pagination.page}
      totalPages={pagination.totalPage}
      totalItems={pagination.totalItems}
      itemsPerPage={pagination.limit}
      onPageChange={(page) => {
        setPagination({ ...pagination, page });
      }}
      isLoading={loading}
    />
  );
};

export default InvoiceOpen;
